import React from 'react';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const ShiftLeftFindingDetail = withErrorBoundary(
  React.lazy(
    () =>
      import('../../../micro-frontends/components/shift-left-finding-detail'),
  ),
);

export const ShiftLeftFindingDetailView = (props: {
  data: { scanId: string; findingId: string };
}) => {
  return <ShiftLeftFindingDetail {...props.data} />;
};
